import InfoCircleTooltip from './InfoCircleTooltip'

export default InfoCircleTooltip
